export default __webpack_public_path__ + "static/media/about-logos.db9bc4b0.png";